var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-tooltip",
    {
      attrs: {
        disable: !_vm.extraOption || !_vm.tooltip,
        content:
          _vm.$store.getters.language === "zh"
            ? _vm.extraOption.chineseName
            : _vm.extraOption.englishName,
        placement: "bottom"
      }
    },
    [
      _c("cargo-advance-select", {
        attrs: {
          disabled: _vm.disabled,
          "select-type": _vm.selectTypeNames.basic_data_Office,
          cache: false,
          filterable: "",
          clearable: _vm.clearable,
          "default-value": _vm.officeId || "",
          "static-options": _vm.options,
          "tag-name": _vm.tagName,
          "tag-value": _vm.tagValue,
          placeholder: _vm.placeholder
        },
        on: {
          parentCallBack: function(p) {
            _vm.$emit("change", p)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }